import {createValue} from "./themeValue";
import {
    COLOR_CURIOSITY_BUTTON_BACKGROUND,
    COLOR_DARK_PURPLE,
    COLOR_PURPLE,
    COLOR_LIGHT_PURPLE,
    COLOR_LIGHT_GREY, COLOR_GREY2, COLOR_WHITE, COLOR_BLACK, COLOR_MEDIUM_GREY, COLOR_GREY
} from "../config/colors";

const config = {
    container: {
        backgroundColor: createValue(COLOR_LIGHT_GREY, {
            'uloop': '#fff',
        }),
        borderColor: createValue(COLOR_MEDIUM_GREY, {
            'uloop': '#efefef',
        }),
        textColor: createValue(COLOR_BLACK, {
            'uloop': '#4c4c4c',
        }),
        radius: createValue('15px', {
            'all': '0',
            'uloop': '2px',
            'liveherehousing': '5px',
        }),
    },
    button: {
        main: {
            radius: createValue('0.25rem', {
                'all': '0',
                'uloop': '3px',
            }),
            borderColor: createValue(COLOR_LIGHT_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#ff640a',
                'liveherehousing': '#fafafa',
            }),
            color: createValue(COLOR_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#ff640a',
                'liveherehousing': '#2b82d9',
            }),
            textColor: createValue(COLOR_WHITE, {
                'csa': '#ffffff !important',
                'cr': '#ffffff !important',
                'uloop': '#ffffff !important',
                'liveherehousing': '#ffffff',
            }),
            hoverColor: createValue(COLOR_DARK_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#fe844e',
                'liveherehousing': '#2b82d9',
            }),
        },
        howItWorks: {
            color: createValue(COLOR_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#1c4a8c',
                'liveherehousing': '#2b82d9',
            }),
        },
        curious: {
            color: createValue(COLOR_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#1d4a8c',
                'liveherehousing': '#2b82d9',
            }),
            backgroundColor: createValue(COLOR_CURIOSITY_BUTTON_BACKGROUND, {
                'csa': '#f6faff',
                'cr': '#f6faff',
                'uloop': '#f0f4f6',
            }),
        },
    },
    footer: {
        backgroundColor: createValue(COLOR_LIGHT_GREY, {
            'uloop': '#fff',
        }),
        borderColor: createValue(COLOR_GREY2, {
            'uloop': '#efefef',
        }),
        textColor: createValue(COLOR_GREY, {
            'uloop': '#4c4c4c',
        }),
        linkColor: createValue(COLOR_BLACK, {
            'csa': '#287dfc',
            'cr': '#1b72ff',
            'uloop': '#1d4a8c',
            'liveherehousing': '#2b82d9',
        }),
    },
    slider: {
        track: {
            color: createValue(COLOR_DARK_PURPLE, {
                'csa': '#104684',
                'cr': '#104684',
                'uloop': '#1d4a8c',
                'liveherehousing': '#2b82d9',
            }),
        }
    },
    select: {
        color: createValue(COLOR_PURPLE, {
            'csa': '#287dfc',
            'cr': '#1b72ff',
            'liveherehousing': '#2b82d9',
        }),
        radius: createValue(6, {
            'all': '0',
            'uloop': '2px',
        }),
    },
    input: {
        radius: createValue(4, {
            'all': '0',
            'uloop': '2px',
        }),
    },
    datePicker: {
        weekDay: {
            color: createValue(COLOR_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#1c4a8c',
                'liveherehousing': '#2b82d9',
            }),
        },
        selected: {
            color: createValue(COLOR_PURPLE, {
                'csa': '#287dfc',
                'cr': '#1b72ff',
                'uloop': '#1c4a8c',
                'liveherehousing': '#2b82d9',
            }),
        },
    },
    strings: {
        button: {
            showMatches: createValue('Show Me My Matches →', {
                'all': 'Match Me With Properties',
            }),
        },
    },
    conditions: {
        questionnaire: {
            agreement: createValue(true, {
                'all': false,
                'csa': true,
                'cr': true,
            }),
        },
        showInfo: {
            moveIn: createValue(true, {
                'all': false,
            }),
            yourInfo: createValue(true, {
                'all': false,
            }),
        },
        changeCollege: {
            title: createValue(false, {
                'all': true,
            }),
        }
    },
    title: {
        marginTop: createValue('0', {
            'all': '20px',
        }),
    },
    schoolElement: {
        height: createValue('65px', {
            'all': '60px',
        }),
        radius: createValue('15px', {
            'all': '0px',
            'uloop': '2px',
            'liveherehousing': '5px',
        }),
        backgroundColor: createValue(COLOR_LIGHT_GREY, {
            'uloop': '#ffffff',
            'liveherehousing': '#fafafa',
        }),
        borderColor: createValue(COLOR_GREY2, {
            'uloop': '#efefef',
            'liveherehousing': '#efefef',
        }),
        headerElement: createValue(false, {
            'csa': '.col-3.col-hr',
            'cr': '#header .col-hr',
        }),
        titleElementStyles: createValue('', {
            'csa': `
                position: absolute;
                top: 0;
                right: 0;
                @media (max-width: 768px) {
                    display: none;
                };
            `,
            'cr': `
                position: absolute;
                top: 0;
                right: 0;
                @media (max-width: 768px) {
                    display: none;
                };
            `,
            'uloop': `
                position: absolute;
                top: 0;
                right: 0;
                @media (max-width: 768px) {
                    display: none;
                };
            `,
            'liveherehousing': `
                position: absolute;
                top: 0;
                right: 0;
                @media (max-width: 768px) {
                    display: none;
                };
            `,
        }),
        headerElementStyles: createValue('', {
            'csa': `
                margin-top: 5px;
                margin-right: 5px;
                display: none;
                @media (max-width: 768px) {
                    display: block;
                }
            `,
            'cr': `
                margin-top: 5px;
                margin-right: 5px;
                display: none;
                @media (max-width: 768px) {
                    margin-top: 0;
                    display: block;
                }
            `,
        }),
        headerElementAdditionalStyles: createValue(false, {
            'csa': `
                .col-3.col-hr {
                    position: relative;
                }
            `,
            'cr': `
                #header .col-hr {
                    position: relative;
                }
            `,
        }),
    },
    leadsLimit: {
        marginTop: createValue('initial', {
            'all': '-20px',
        }),
        position: createValue('absolute', {
            'all': 'relative',
        }),
    },
    tracking: {
        googleAnalyticsId: createValue('UA-172819487-1', {
            'csa': 'UA-38740873-1',
            'cr': 'UA-51654532-1',
            'uloop': 'UA-1045428-1',
            'liveherehousing': 'UA-169294328-1',
        }),
        googleGTMId: createValue('GTM-MCW3L4K', {
            'csa': 'GTM-M95CMT',
            'cr': 'GTM-M9D7VM6',
            'uloop': 'GTM-597HBK',
            'liveherehousing': 'GTM-N7ZX9VX',
        }),
    },
    site: {
        name: createValue('CribWiz', {
            'csa': 'College Student Apartments',
            'cr': 'College Rentals',
            'uloop': 'Uloop',
            'liveherehousing': 'Live Here College Housing',
        }),
    },
};

export default config;
